/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Image,
  Input,
  Message,
  Modal,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Typography,
  Upload
} from '@arco-design/web-react';
import './index.scss';
import { get, post } from '../requestNew';
import { API_CONFIG } from '../utils';
import { Item } from './types';

const Option = Select.Option;
const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function Pay() {
  const [form] = Form.useForm<Item>();
  const [loading, setLoading] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [sessionList, setSessionList] = useState<{ label: string; value: string }[]>([]);
  const [gameSession, setGameSession] = useState('');
  const [dataList, setDataList] = useState<Item[]>([]);

  const recordRef = useRef({});

  const columns: TableColumnProps[] = [
    {
      title: '标题',
      dataIndex: 'groupTypeName',
      width: 120
    },
    {
      title: '图片',
      dataIndex: 'wechatGroup',
      width: 260,
      render: arr => {
        return (
          <div>
            {arr.map((item: { url: string }, index: number) => (
              <Image style={{ marginRight: 8 }} key={`${item.url}-${index}`} width={50} height={50} src={item.url} alt="" />
            ))}
          </div>
        );
      }
    },
    {
      title: '是否生效',
      dataIndex: 'isValid',
      width: 120,
      render: (val: number, record: Item) => (
        <Switch
          checked={val === 1}
          checkedText="是"
          uncheckedText="否"
          onChange={(isValid: boolean) => checkChange(isValid, record)}
        />
      )
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
        </>
      )
    }
  ];

  const getList = () => {
    setLoading(true);
    // 暂时写死 后续需要通过设置来限制是否可以查看其他赛季的数据
    get('/groupType/getGroupTypeBySession', { gameSession})
      .then((res: any) => {
        if (res && res.data ) {
          const list = res.data.map((item: any) => {
            return {
              ...item,
              wechatGroup: [{ url: item.wechatGroup || '' }]
            };
          });
          setDataList(list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkChange = (isValid: boolean, record: Item) => {
    const data = {
      ...record,
      isValid: isValid ? 1 : 0
    };
    const wechatGroup = data.wechatGroup[0];
    data.wechatGroup = wechatGroup.response?.data || wechatGroup.url || '';
    post('/groupType/updateGroupTypeById', data).then(res => {
      if (res) {
        Message.success('操作成功');
        getList();
        editCancel();
      }
    });
  };

  // 修改相关
  const edit = (record: Item) => {
    form.setFieldsValue(record);
    setVisibleEdit(true);
    recordRef.current = record;
  };

  const onEdit = () => {
    form.validate().then(res => {
      setConfirmLoading(true);
      const data = {
        ...recordRef.current,
        ...res
      };

      const wechatGroup = data.wechatGroup[0];
      data.wechatGroup = wechatGroup.response?.data || wechatGroup.url || '';

      post('/groupType/updateGroupTypeById', data)
        .then(res => {
          if (res) {
            Message.success('操作成功');
            getList();
            editCancel();
          }
        })
        .finally(() => setConfirmLoading(false));
    });
  };

  const editCancel = () => {
    setVisibleEdit(false);
    setConfirmLoading(false);
    form.resetFields();
  };

  useEffect(() => {
    if (gameSession) {
      getList();
    }
  }, [gameSession]);

  useEffect(() => {
    get('/gameConfig/getUmsGameConfigList').then((res: any) => {
      if (res && res.data ) {
        const list = res.data.map((item: any) => {
          const { gameSession } = item;
          return { label: gameSession, value: gameSession };
        });
        setSessionList(list);
        setGameSession(list[0].value);
      }
    });
  }, []);

  return (
    <div className="pay table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <div className="filter-item">
          <Typography.Text>赛季:</Typography.Text>
          <Select onChange={setGameSession} value={gameSession} style={{ width: 100 }}>
            {sessionList.map(item => (
              <Option value={item.value} key={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </div>
        <Button
          className="filter-item"
          type="primary"
          onClick={() => {
            getList();
          }}
        >
          查询
        </Button> 
      </Space>
      <div className="table-content">
        <Table
          loading={loading}
          columns={columns}
          data={dataList}
          pagination={{ sizeCanChange: true, defaultPageSize: 10, showTotal: true }}
          rowKey="id"
          className="table-scroll"
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal title="数据修改" visible={visibleEdit} onOk={onEdit} confirmLoading={confirmLoading} onCancel={editCancel}>
        <Form {...formItemLayout} form={form}>
          <FormItem label="标题" field="groupTypeName">
            <Input placeholder="" />
          </FormItem>
          <FormItem label="图片" field="wechatGroup" triggerPropName="fileList">
            <Upload
              multiple={false}
              limit={1}
              imagePreview
              action={API_CONFIG.uploadUrl}
              listType="picture-card"
            />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default Pay;
